import { ContentCell } from '../data-grid/components/content-cell';
import type { DateTimeViewProps } from './date-time-view.types';

export const DateTimeView = (props: DateTimeViewProps) => {
	const { date, timezone = 'UTC', locale, parsedContent, dateStyle = 'medium', timeStyle = 'short' } = props;

	if (!date) return null;

	if (dateStyle === null && timeStyle === null) {
		console.warn('dateStyle and timeStyle cannot be null at the same time');
		return null;
	}

	try {
		const dateObj = new Date(date);

		if (isNaN(dateObj.getTime())) {
			return null;
		}

		// Format the date and time
		const formattedDate = dateStyle
			? new Intl.DateTimeFormat(locale, {
					dateStyle,
					timeZone: timezone,
				}).format(dateObj)
			: undefined;

		const formattedTime = timeStyle
			? new Intl.DateTimeFormat(locale, {
					timeStyle,
					timeZone: timezone,
				}).format(dateObj)
			: undefined;

		return (
			<ContentCell
				primaryContent={parsedContent?.primaryContent || formattedDate}
				secondaryContent={parsedContent?.secondaryContent || formattedTime}
				moreContent={parsedContent?.moreContent}
				moreContentHover={parsedContent?.moreContentHover}
				moreContentLink={parsedContent?.moreContentLink}
				icon={parsedContent?.icon}
				iconOptions={parsedContent?.iconOptions}
			/>
		);
	} catch (error) {
		console.error('Error formatting datetime:', error);
		return null;
	}
};
